"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var statisticLarge = '40px';
var statisticSmall = '32px';
var StyledStatistic = _styledComponents["default"].div.withConfig({
  displayName: "Statisticstyle__StyledStatistic",
  componentId: "sc-14qq94w-0"
})(["", ""], function (props) {
  var color = props.color,
    labelColor = props.labelColor,
    size = props.size,
    _props$theme = props.theme,
    typography = _props$theme.typography,
    spacing = _props$theme.spacing;
  var _typography$size = typography.size,
    h2 = _typography$size.h2,
    table = _typography$size.table,
    base = _typography$size.base;
  var countFontSize = size === 'large' ? statisticLarge : statisticSmall;
  var labelFontSize = 0;
  switch (size) {
    case 'large':
      labelFontSize = h2;
      break;
    case 'medium':
      labelFontSize = base;
      break;
    default:
      labelFontSize = table;
  }
  return (0, _styledComponents.css)(["h3{font-size:", ";color:", ";margin-bottom:", ";}p{font-size:", ";color:", ";line-height:", ";margin-bottom:0;}"], countFontSize, color, spacing.xTiny, labelFontSize, labelColor, typography.lineHeight.paragraphSmall);
});
StyledStatistic.displayName = 'StyledStatistic';
var _default = exports["default"] = StyledStatistic;